import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/assets/styles/index.css';
import '@/assets/styles/fonts.css';
import App from './App';
import { SnackbarProvider } from './contexts/SnackbarContext';
import reportWebVitals from './reportWebVitals';
import { TourProvider } from '@reactour/tour';

const steps = [
	{
		selector: '.input-box',
		content: ['۱. شروع گفتگو', <br />, 'برای شروع، سوال خود را در این کادر بنویسید و دکمه ارسال را بزنید.'],
		position: 'top'
	},
	{
		selector: '.open-new-chat',
		position: 'left',
		content: ['۲. مکالمه جدید', <br />, 'هر زمان که خواستید موضوع را عوض کنید، با کلیک روی این دکمه، یک گفتگوی جدید شروع کنید.'],
	},
	{
		selector: '.search-chats',
		position: 'left',
		content: ['۳. جستجو پیام مورد نظر', <br />, 'برای یافتن پیام های قدیمی میتوانید از این قسمت استفاده کنید.']
	},
	{
		selector: '.export-wrapper',
		position: 'right',
		content: ['۴. خروجی پیام مورد نظر', <br />, 'هر زمان که نیاز به خروجی از یک پاسخ در فرمت های مختلف داشتید از این دکمه استفاده کنید.']
	},
	{
		selector: '.assistant-msg-wrapper .copy-button',
		position: 'right',
		content: ['۵. کپی کردن متن', <br />, 'با این دکمه می‌توانید به راحتی متن کامل پاسخ سامانه را کپی کنید.']
	},
	{
		selector: '.attach-btn',
		position: 'right',
		content: ['۶. امکانات بیشتر', <br />, 'با این دکمه می‌توانید از امکانات بیشتر سایت الصاق فایل و سوال از وبسایت سازمان استفاده کنید.']
	},
]

const styles = {
	maskWrapper: (base) => ({
		...base,
		color: 'rgba(0, 0, 0, 0.25)'
	}),
	popover: (base) => ({
		...base,
		borderRadius: '16px',
		backgroundColor: 'var(--primary-Green-10)',
		color: 'var(--primary-Green-Base)',
		boxShadow: 'var(--help-shadow)',
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '20px',
		padding: '30px 16px',
	}),
	close: (base) => ({
		...base,
		top: '16px',
		right: '16px'
	})
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<SnackbarProvider>
			<TourProvider
				steps={steps}
				badgeContent={() => null}
				onClickClose={({ setCurrentStep, setIsOpen }) => { setCurrentStep(0); setIsOpen(false); }}
				showBadge={false}
				showDots={false}
				styles={styles}
			>
				<App />
			</TourProvider>
		</SnackbarProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
